import React, { useState } from "react";
import { Box, Stack, TextField, Button } from "@mui/material";
import { COLORS, RADIUS, PROJECT_COLORS } from "./ticketTheme";

/** Inline "name + color swatches + Create/Cancel" row — matches the
 * reference's "+ New project" / "+ Add group" creation flow exactly. */
export default function NewProjectRow({ onCreate, onCancel }) {
  const [name, setName] = useState("");
  const [color, setColor] = useState(PROJECT_COLORS[0]);
  const [submitting, setSubmitting] = useState(false);

  const handleCreate = async () => {
    if (!name.trim() || submitting) return;
    setSubmitting(true);
    try {
      await onCreate({ name: name.trim(), color });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      sx={{
        p: 1.5,
        border: "1px solid",
        borderColor: COLORS.accent,
        borderRadius: `${RADIUS.field}px`,
        bgcolor: COLORS.cardBg,
      }}
    >
      <TextField
        autoFocus
        placeholder="Project name..."
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleCreate()}
        size="small"
        sx={{ flex: 1 }}
      />
      <Stack direction="row" spacing={1}>
        {PROJECT_COLORS.map((c) => (
          <Box
            key={c}
            onClick={() => setColor(c)}
            sx={{
              width: 22,
              height: 22,
              borderRadius: "50%",
              bgcolor: c,
              cursor: "pointer",
              border:
                color === c
                  ? `2px solid ${COLORS.textPrimary}`
                  : "2px solid transparent",
              outline: color === c ? `2px solid ${c}` : "none",
              outlineOffset: 2,
            }}
          />
        ))}
      </Stack>
      <Button
        onClick={onCancel}
        disabled={submitting}
        sx={{ textTransform: "none", color: COLORS.textSecondary }}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        onClick={handleCreate}
        disabled={!name.trim() || submitting}
        sx={{
          textTransform: "none",
          fontWeight: 700,
          bgcolor: COLORS.accent,
          borderRadius: `${RADIUS.field}px`,
          "&:hover": { bgcolor: "#5B49D6" },
        }}
      >
        Create
      </Button>
    </Stack>
  );
}
